import { app } from "@/config";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer id="footer">
      <hr className="w-11/12 mx-auto" />

      <section className="container py-20 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-12 gap-y-8">
        <div className="col-span-full xl:col-span-2">
          <a className="font-bold text-xl flex" href="/">
            {app.name}
          </a>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("about")}</h3>
          <div>
            <a className="opacity-60 hover:opacity-100" href="/#features">
              {t("features")}
            </a>
          </div>

          <div>
            <a className="opacity-60 hover:opacity-100" href="/#pricing">
              {t("pricing")}
            </a>
          </div>

          <div>
            <a className="opacity-60 hover:opacity-100" href="/#faq">
              FAQ
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">{t("legal")}</h3>
          <div>
            <a className="opacity-60 hover:opacity-100" href="/terms">
              {t("terms-of-service")}
            </a>
          </div>

          <div>
            <a className="opacity-60 hover:opacity-100" href="/privacy">
              {t("privacy-policy")}
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-bold text-lg">Resources</h3>
          <div>
            <a className="opacity-60 hover:opacity-100" href="/blog">
              Blog
            </a>
          </div>
        </div>
      </section>

      <section className="container pb-14 text-center">
        <h3>&copy; 2025 {app.name}</h3>
      </section>
    </footer>
  );
};
